/**
 * TODO: The functionality in this file duplicates the functionality in
 * product-option-form-reset.js. This component should be updated to somehow
 * reuse the functionality provided by product-option-form. Important to note
 * that this file implements more complex functionality than
 * product-option-form-reset.js.
 */
(function (window) {
  window.componentEvents.on('consumer-rx-form-instantiate', init);

  /**
   * Instantiate automatic form reset functionality.
   */
  function init(form) {
    const steps = Array.from(form.querySelectorAll('[data-rx-step]'));

    steps.forEach((step) => {
      step.addEventListener('change', (event) => {
        handlePartialReset(event.currentTarget);
      });
    });

    // Reset the form when the modal is closed.
    window.componentEvents.on('modal-change', (data) => {
      if (data.id && data.id.match('consumer-rx-modal') && data.action === 'close') {
        form.reset();
        window.componentEvents.emitEvent(`rx-form-reset-${form.id}`, form);
      }
    });

    /**
     * Kick off a partial reset when a change occurs in a given step.
     *
     * @param step A reference to the DOM Node of a step.
     */
    function handlePartialReset(step) {
      // Construct a new array of steps that come _after_ the current step.
      const stepsToReset = steps.slice(parseInt(step.dataset.rxStep));
      stepsToReset.forEach(resetFieldsWithin);
    }

    /**
     * Reset the fields within a given step.
     *
     * @param step A reference to the DOM Node of a step.
     */
    function resetFieldsWithin(step) {
      // File inputs are reset by the consumer-rx-form-upload module. We only
      // have to manually reset selects and inputs that can be checked.
      resetChecked(step);
      resetSelects(step);
      window.componentEvents.emitEvent(`rx-form-partial-reset-${form.id}`, [{
        stepToReset: step.dataset.rxStep,
      }]);
    }

    /**
     * Reset form controls that can be checked within a given step.
     *
     * @param step A reference to the DOM Node of a step.
     */
    function resetChecked(step) {
      const checkedInputs = step.querySelectorAll('input:checked');
      checkedInputs.forEach((input) => input.checked = false);
    }

    /**
     * Reset select elements within a given step.
     *
     * @param step A reference to the DOM Node of a step.
     */
    function resetSelects(step) {
      const selects = step.querySelectorAll('select');
      selects.forEach((select) => select.selectedIndex = 0);
    }
  }
})(window);
